"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWithdrawMethodParams = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const constants_1 = require("./constants");
const mapWithdrawMethodParams = ({ methodParamsList, formData, paymentAccount, }) => {
    if (!(0, isEmpty_1.default)(paymentAccount)) {
        return {
            ...getValuesFromFormData(methodParamsList, formData),
            ...getFieldsForAccountKey(methodParamsList, paymentAccount),
        };
    }
    return getValuesFromFormData(methodParamsList, formData);
};
exports.mapWithdrawMethodParams = mapWithdrawMethodParams;
const getValuesFromFormData = (methodParamsList, formData) => methodParamsList.reduce((acc, cur) => {
    if (!(cur === null || cur === void 0 ? void 0 : cur.type) || !(cur === null || cur === void 0 ? void 0 : cur.name)) {
        return acc;
    }
    return {
        ...acc,
        [cur.name]: formData[constants_1.METHODS_FOR_MAPPING_FIELDS[cur.type]],
    };
}, {});
const getFieldsForAccountKey = (methodParamsList, paymentAccount) => methodParamsList.reduce((acc, cur) => {
    if (!(cur === null || cur === void 0 ? void 0 : cur.type) || !(cur === null || cur === void 0 ? void 0 : cur.name)) {
        return acc;
    }
    return {
        ...acc,
        [cur.name]: paymentAccount[constants_1.PARAMS_KEYS_FOR_ACCOUNT_KEY[cur.type]],
    };
}, {});
//# sourceMappingURL=utils.js.map